<template>
    <v-ons-page id="menuPage">
        <v-ons-toolbar>
            <div class="left zindex9 icon-left">
                <v-ons-back-button material></v-ons-back-button>
            </div>
            <div :class="{'text-center minus7-ml':'!back' }" class="center zindex1">
              <slot> {{ this.titleMap }}</slot>
            </div>
            <div class="right zindex9 icon-right" >

            </div>
        </v-ons-toolbar>
        <!--<div class="header">-->
        <!--<img src="../assets/onsenui-logo.png">-->
        <!--</div>-->

      <!-- https://www.image-map.net/ -->
        <div class="fullImage centerAll" style="height: 100%">

          <img :class="{rotateImage: rotate,hidde : visible}" id="imagefullScreen" class="fullScreen" usemap="#image-map" :src="image"/>
          <PinchImageMenu :rotate="rotate" :src="image" :min-zoom="1" :max-zoom="2.5"></PinchImageMenu>


          <map name="image-map">
            <area v-for="(item,index) in menuItems" @click="push(index)" target="" alt="" href="#" title="" :coords="item.coords" shape="circle">
          </map>

        </div>
    </v-ons-page>
</template>

<script>
    import TopBar from '../components/TopBar'
    import constants from '../constants'
    import AudioPage from './AudioPage'
    import TextPage from './TextPage'
    import GalleryPage from './GalleryPage'
    import ImagePage from './ImagePage'
    import PinchImageMenu from '../components/PinchImageMenu'

    export default {
        name: 'menuImage',
        components: {
            TopBar,
            PinchImageMenu,
        },
        data: function () {
            return {
                //https://www.image-map.net/
              coords : [
                "516,316,29",
                "446,465,27",
                "536,545,27",
                "536,606,28",
                "459,634,29",
                "381,542,28",
                "381,605,29",
                "379,665,28",
                "306,634,27",
                "235,635,27",
                "306,542,29",
                "236,542,31",
                "161,635,28",
                "80,635,29",
                "79,524,33",
                "79,424,29",
                "80,281,32",
                "79,146,31",
                "79,64,30",
                "161,52,29",
                "162,116,30",
                "263,149,27",
                "370,148,30",
                "321,846,111",
                "0,0,0",
                "0,0,0",
                "0,0,0",
                "0,0,0",
                "0,0,0",
                "0,0,0",
                "0,0,0",
                "0,0,0",
                "0,0,0",
                "0,0,0",
                "0,0,0",
                "0,0,0"
              ]

              ,

                widthImageAssets:640,
                heighImageAssets:922,

                menuItems: this.$t("message.menuItems"),
                title: this.$t("message.title"),
                titleMap: this.$t("message.titleMap"),
                /*map: require('../assets/img/art/Plano1.png'),*/
                icon_map: require('../assets/img/UI/gota_mapa.png'),

                closeImage: require('../assets/img/UI/Recurso 33.png'),
                onsNavigatorOptions: {
                    animation: 'none'
                },
                rotate: false,
                visible: false,

                menuIndex:0,
                timeoutID:null,
                image:require('../assets/img/art/'+this.$t("message.map"))

            }
        },

        computed: {
            visitType: {
                get() {
                    return this.$store.state.visit.type
                },
            },
            fullMenuItems() {

                this.$store.state.visit.type=constants.VISIT_TYPE_LISTEN

              this.menuItems.forEach((elementMenuItem,indexItem) => {


                var idioma="";
                let lang=this.$i18n.locale;

                if (lang == "Castellano") {
                  idioma = "ESP";
                } else if (lang == "English") {
                  idioma = "ENG";
                } else if (lang == "Français") {
                  idioma = "FRA";
                } else if (lang == "Català") {
                  idioma = "CAT";
                } else if (lang == "Deutsch") {
                  idioma = "DEU";
                } else if (lang == "Português") {
                  idioma = "POR";
                } else if (lang == "한국어") {
                  idioma = "KOR";
                } else if (lang == "官話") {
                  idioma = "CHI";
                }

                elementMenuItem.path_audio =  "/audios/"+idioma+"/"+ elementMenuItem.audio;

                if(elementMenuItem.isCredits) {
                  elementMenuItem.imgCredit = elementMenuItem.img;
                }


                console.log(elementMenuItem.path_audio);
              });
              return this.menuItems;
            },


        },
        mounted() {
          const img = document.getElementById('imagefullScreen');
          img.addEventListener('load', () => {
            const width = document.getElementById('imagefullScreen').clientWidth;
            const height = document.getElementById('imagefullScreen').clientHeight;

            console.log("width - height: "+width+" - "+height);

            if (width > height) {
              this.rotate = true;
            }
            this.visible = true;
            console.log(width);
            console.log(height);
            console.log(this.rotate);
            document.getElementById('imagefullScreen').display = "none";

            this.refreshCoordsMap();
          });



            //fullMenuItems();
//            let titles = document.getElementsByClassName("title");
////            console.log(titles);
////            for (let title of titles) {
////                console.log(title.height);
////            }
//            Array.from(document.getElementsByClassName("title")).forEach(function(item) {
////                console.log(item);
//                if (item instanceof HTMLElement) {
//                    console.log(item.height);
//                    console.log(item.style.height);
////                    item.style.height = "10px";
//                }
//            });
        },
        methods: {

            getCoordsMap(){
                let index=this.menuIndex;
                console.log("getCoordsMap: "+index);

                let widthImage=this.widthImageAssets;
                let heightImage=this.heighImageAssets;

                let widthImageResize=document.getElementById('pinch-img').clientWidth;
                let heightImageResize= document.getElementById('pinch-img').clientHeight;
                let coordsImage=this.coords[index];

                console.log("index:"+index);
                console.log("widthImageResize:"+widthImageResize);
                console.log("heightImageResize:"+heightImageResize);
                console.log("coordsImage:"+coordsImage);

                let coordsArray = coordsImage.split(',');
                let x=parseInt((coordsArray[0]*widthImageResize)/widthImage);
                let y=parseInt((coordsArray[1]*heightImageResize)/heightImage);
                let r=parseInt((coordsArray[2]*widthImageResize)/widthImage);
                let newCoords=x+','+y+','+r;

                console.log(newCoords);

                return newCoords;
            },

            refreshCoordsMap(){
                if(this.timeoutID!=null) {
                    clearTimeout(this.timeoutID);
                }
                this.timeoutID=setTimeout(() => {
                    this.menuItems=this.fullMenuItemsRefresh();
                    this.$forceUpdate();
                }, 1000);
            },

            fullMenuItemsRefresh() {

                this.$store.state.visit.type=constants.VISIT_TYPE_LISTEN

                this.menuItems.forEach((elementMenuItem,indexItem) => {

                    console.log("indexItem: "+indexItem);
                    this.menuIndex=indexItem;
                    elementMenuItem.coords=this.getCoordsMap();

                    //constants.URL_AUDIO

                    var idioma="";
                    let lang=this.$i18n.locale;
                    if (lang == "Castellano") {
                        idioma = "ESP";
                    } else if (lang == "English") {
                        idioma = "ENG";
                    } else if (lang == "Français") {
                        idioma = "FRA";
                    } else if (lang == "Català") {
                      idioma = "CAT";
                    } else if (lang == "Deutsch") {
                        idioma = "DEU";
                    } else if (lang == "Português") {
                        idioma = "POR";
                    } else if (lang == "한국어") {
                        idioma = "KOR";
                    } else if (lang == "官話") {
                        idioma = "CHI";
                    }

                    elementMenuItem.path_audio =  "/audios/"+idioma+"/"+ elementMenuItem.audio;

                    if(elementMenuItem.isCredits) {
                        elementMenuItem.imgCredit = elementMenuItem.img;
                    }


                    console.log(elementMenuItem.path_audio);
                });
                return this.menuItems;
            },

            push(index) {

                // Si el index es 6, abrir una URL externa
                /*if (index === 6) {
                    const externalUrl = 'https://catedralsegovia.es/visita-panoramica-de-la-torre/';
                    window.open(externalUrl, '_blank');
                    return; // Detener la ejecución de la función después de abrir la URL
                }*/

                console.log(index);
                let item=this.menuItems[index];
                console.log(item);

                if (item.isGallery) {
                    this.$emit('push', {
                        extends: GalleryPage,
                        onsNavigatorProps: {
                            item: item
                        }
                    });
                } else if (item.isCredits) {
                    this.$emit('push', {
                        extends: TextPage,
                        onsNavigatorProps: {
                            item: item
                        }
                    });
                }
                else if (this.$store.state.visit.type === constants.VISIT_TYPE_READ) {

                    this.$emit('push', {
                        extends: TextPage,
                        onsNavigatorProps: {
                            item: item
                        }
                    });
                } else if (this.$store.state.visit.type === constants.VISIT_TYPE_LISTEN) {
                    if (item.imagesAudio) {
                        item.img = item.imagesAudio[0].img;
                        console.log('HASSS IMAGES AUDIOOOS¡¡¡¡');
                        console.log(item.imagesAudio);
                    }
                    this.$emit('push', {
                        extends: AudioPage,
                        onsNavigatorProps: {
                            item: item
                        }
                    });
                }

//                this.$i18n.locale = lang;
//                this.$store.commit('langs/toggle', lang)
//                this.$emit('push', {
//                    extends: MenuPage,
//
//                });
            },
            pushMap(){
                console.log("push map "+this.map);
                this.$emit('push', {
                    extends: ImagePage,
                    onsNavigatorProps: {
                        image: this.map,
                        title: this.titleMap

                    }
                });
            }
        },
    }
</script>
<style lang="css" src="../assets/css/styles.css"/>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
    .padding0 {
        padding: 0;
    }

    #menuPage .list-item__center {
        padding: 0;

    }

    .content {
        margin: 0px 0px -6px 0px;
        width: 100%;
    }

    /*.title {
        position: absolute;
        bottom: 15%;
        left: 17%;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        width: 83%;
    }*/

    .author {
        position: absolute;
        bottom: 2%;
        left: 17%;
        /*font-size: 18pt;*/
    }

    /*.menulist{
        margin-top: 27% !important;
    }*/

    .zindex9 {
        z-index: 99;
    }
    .zindex1 {
        z-index: 1;
    }
    .text-center {
        text-align: center;
    }

    .toolbar__title {
        font-size: 3.75vw;
      color: white;
    }

    .toolbar__left {
        width: 21%;
    }

    .icon-right img {
        height: 41px;
        padding-right: 8px;
    }


    .toolbar--material__left {
        width: 15%;
    }

    .toolbar {
        height: auto;
        min-height:56px;
        padding-top: 7% !important;
    }

    @media (min-width: 800px) {
        .toolbar {
            padding-top: 30px !important;
        }

    }



    .center {
      flex: 1;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .rotateImage {
      transform: rotate(90deg);
      max-width: 145vw !important;
    }

    .imageClose {
      top: 3%;
      position: absolute;
      left: 90vw;
      border-radius: 50%;
      background-color: black;
      padding: 5px;
      opacity: 0.7;
      z-index: 999;
      height: 5vw;
    }

    .fullScreen {
      max-width: 100%;
      max-height: 100%;
    }

    .hidde {
      display: none;
    }


</style>



// WEBPACK FOOTER //
// src/pages/MenuImagePage.vue